const kexProfilesState = {
    requestingCreateKEXProfile: false,
    requestingModifyKEXProfile: false,
    requestingRemoveKEXProfile: false,
    requestingSourceKEXProfile: false,
    requestingTargetKEXProfile: false,
    sourceKEXProfile: undefined,
    targetKEXProfile: undefined
};
export default kexProfilesState;
